import { render } from "./EditorModal.vue?vue&type=template&id=4784fc42&scoped=true"
import script from "./EditorModal.vue?vue&type=script&lang=ts"
export * from "./EditorModal.vue?vue&type=script&lang=ts"

import "./EditorModal.vue?vue&type=style&index=0&id=4784fc42&lang=scss"
import "./EditorModal.vue?vue&type=style&index=1&id=4784fc42&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4784fc42"

export default script